export const debounce = (timeMs, method) => {
  let timeout

  return function(...methodArguments) {
    // eslint-disable-next-line promise/avoid-new
    return new Promise((resolve) => {
      const later = () => {
        timeout = null

        resolve(method.apply(this, methodArguments))
      }

      timeout && clearTimeout(timeout)
      timeout = setTimeout(later, timeMs)
    })
  }
}

// eslint-disable-next-line promise/avoid-new
export const timeout = milliseconds => new Promise((resolve) => {
  setTimeout(resolve, milliseconds)
})

export const chainPromises = promises => promises
  .reduce(async (previousPromise, nextPromise) => {
    await previousPromise
    return nextPromise()
  }, Promise.resolve())

export const intoSequentialPromise = async (previous, current, index) => [
  ...await previous,
  await current(index),
]
